(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slider = document.querySelector('[data-announcement-slider]');
    if (!slider) return;
    var messages = slider.querySelectorAll('.announcement-bar__message');
    if (messages.length <= 1) return;
    var current = 0;
    setInterval(function() {
      messages[current].classList.remove('is-active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('is-active');
    }, 4000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-before-after-track]');
    if (!track) return;

    var cards = track.querySelectorAll('[data-before-after-card]');
    var prevBtn = document.querySelector('[data-before-after-prev]');
    var nextBtn = document.querySelector('[data-before-after-next]');
    var dots = document.querySelectorAll('[data-before-after-dot]');
    var current = 0;

    function scrollToIndex(index) {
      if (index < 0) index = 0;
      if (index >= cards.length) index = cards.length - 1;
      cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      current = index;
      updateDots();
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('before-after__dot--active', i === current);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(current + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToIndex(parseInt(dot.getAttribute('data-before-after-dot'), 10));
      });
    });

    // Update active dot on scroll
    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var closest = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var cardRect = card.getBoundingClientRect();
          var cardCenter = cardRect.left + cardRect.width / 2;
          var dist = Math.abs(cardCenter - trackCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        current = closest;
        updateDots();
      }, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.getElementById('hb-video-modal');
    if (!modal) return;

    var iframe = modal.querySelector('[data-video-src]');
    var videoSrc = iframe ? iframe.getAttribute('data-video-src') : null;

    function openModal() {
      if (iframe && videoSrc) { iframe.src = videoSrc; }
      modal.classList.add('hb-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hb-modal-open');
      var closeBtn = modal.querySelector('.hb-modal__close');
      if (closeBtn) { setTimeout(function () { closeBtn.focus(); }, 30); }
    }

    function closeModal() {
      modal.classList.remove('hb-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hb-modal-open');
      if (iframe) { iframe.src = ''; }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hb-video-open]')) { openModal(); return; }
      if (e.target.closest('[data-hb-close]')) { closeModal(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('hb-modal--open')) { closeModal(); }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var thumbs = document.querySelectorAll('[data-thumb-index]');
    var items = document.querySelectorAll('[data-gallery-item]');
    if (!thumbs.length || !items.length) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        items.forEach(function(item) { item.classList.remove('is-active'); });
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        if (items[index]) items[index].classList.add('is-active');
        thumb.classList.add('is-active');
      });
    });
  })();

  // Modal system: How It Works + Example Busts
  (function () {
    var inCustomizer = window.Shopify && window.Shopify.designMode;

    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    ready(function () {
      var hiwSection = document.querySelector('.how-it-works');
      var hiwInner   = hiwSection && hiwSection.querySelector('.how-it-works__inner');
      var hiwTarget  = document.getElementById('mp-modal-hiw-content');
      if (hiwInner && hiwTarget) {
        hiwTarget.appendChild(hiwInner.cloneNode(true));
        if (!inCustomizer) hiwSection.style.display = 'none';
      }

      var baSection = document.querySelector('.before-after');
      var baInner   = baSection && baSection.querySelector('.before-after__inner');
      var baTarget  = document.getElementById('mp-modal-examples-content');
      if (baInner && baTarget) {
        var clone = baInner.cloneNode(true);
        clone.classList.add('before-after__inner--modal');
        baTarget.appendChild(clone);
        if (!inCustomizer) baSection.style.display = 'none';
      }
    });

    function initCarouselIn(container) {
      var track = container.querySelector('[data-before-after-track]');
      if (!track) return;
      var cards = Array.from(track.querySelectorAll('[data-before-after-card]'));
      var prev  = container.querySelector('[data-before-after-prev]');
      var next  = container.querySelector('[data-before-after-next]');
      var dots  = Array.from(container.querySelectorAll('[data-before-after-dot]'));
      var cur   = 0;

      function go(idx) {
        cur = Math.max(0, Math.min(idx, cards.length - 1));
        if (cards[cur]) cards[cur].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        dots.forEach(function (d, i) { d.classList.toggle('before-after__dot--active', i === cur); });
      }

      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-before-after-dot'), 10));
        });
      });
    }

    function openModal(modal) {
      var videoFrame = modal.querySelector('[data-video-src]');
      if (videoFrame) { videoFrame.src = videoFrame.getAttribute('data-video-src'); }
      modal.classList.add('mp-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mp-modal-open');
      var btn = modal.querySelector('.mp-modal__close');
      if (btn) setTimeout(function () { btn.focus(); }, 30);
    }

    function closeModal(modal) {
      modal.classList.remove('mp-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mp-modal-open');
      var videoFrame = modal.querySelector('[data-video-src]');
      if (videoFrame) { videoFrame.src = ''; }
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-mp-modal-open]');
      if (opener) {
        var target = document.getElementById(opener.getAttribute('data-mp-modal-open'));
        if (target) openModal(target);
        return;
      }
      var closer = e.target.closest('[data-mp-backdrop],[data-mp-close]');
      if (closer) {
        var modal = closer.closest('.mp-modal');
        if (modal) closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.mp-modal--open').forEach(closeModal);
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
